import { IIdName } from "./commonDtos";
import { DropdownItem } from "./dropdownInterfaces";
import { ISearchParameters, ITableReport, Report } from "./TableInterfaces";

export enum ProgressStatus {
  Success = 1,
  Fail,
  Pending,
}

export enum ProgressType {
  UpdatePortfo = "UpdatePortfo",
  UpdateApplyPlan = "UpdateApplyPlan",
  UpdateTradingBook = "UpdateTradingBook",
  RemainingRequests = "RemainingRequests",
  CheckRequests = "CheckRequests",
}

export interface IApplyOptionProgress {
  type: number;
  typeStr: string;
  status: ProgressStatus;
  statusStr: string;
  lastStatusDate: string;
  lastStatusTime: string;
}

export interface IIdNameReason extends IIdName {
  reason: string;
}

export interface IApplyOptionConfig {
  applyCallMargin: number;
  applyPutMargin: number;
  applyRemainedDay: number;
  workerEnabled: boolean;
}

export interface IApplyOptionInsMarginConfig {
  insId: string;
  instrumentName: string;
  callMargin: number;
  putMargin: number;
}

export interface IQueueStatusTableReport extends ITableReport {
  instrumentName: string;
  queue: string;
  callMargin: number;
  putMargin: number;
  insId: string;
}

export interface ISubmitRequstsTableRequests extends ITableReport {}

export interface ISubmitRequstsTableResponse extends Report<ISubmitRequstsTableRequests> {
  total: number;
  remaining: number;
  submitted: number;
}

export interface IProtfoUser extends IIdName {
  fullName: string;
}

export enum OrderSide {
  Buy = 1,
  Sell = 2,
}

export interface IApplyOptionsCommonSearchParam extends ISearchParameters {
  accountId?: number;
  insId?: number;
  status?: number;
  planId?: number;
  showInactive?: boolean;
  showOldPortfolio?: boolean;
  showConflictsOnly?: boolean;
  showOutOfTolerance?: boolean;
  onlyShowPlansWithResult?: boolean;
  broker?: string;
  positionSide?: OrderSide;
}

export interface IConflictTableReport extends ITableReport {
  planId: number | null;
  user: string;
  symbol: string;
  statusStr: string;
  planBuyPositionCount: number | null;
  omsBuyPositionCount: number | null;
  omsSubmittedCount: number | null;
  omsMaxAction: boolean | null;
  lastRequestStatusStr: string;
  enableManualSend: boolean;
}

export interface IOmsResultTableReport extends ITableReport {
  user: string;
  symbol: string;
  positionSideStr: string;
  requestedByPlatformStr: string;
  planStatusStr: string;
  requestStatusStr: string;
  volume: number;
  acceptedVolume: number | null;
  defaultVolume: number | null;
  settlementAmount: number | null;
  defaultAmount: number | null;
  lastUpdateDate: string;
}

export interface IUpdatePortfoStatus {
  lastUpdate: string;
  failUsers: IProtfoUser[];
  usersWithOutOption: IProtfoUser[];
  usersWithOption: IProtfoUser[];
}

export interface IAdjustmentLogsSearchParam extends ISearchParameters {
  date: string;
  fromTime: string;
  fromTimeISO: string;
  toTime: string;
  toTimeISO: string;
  params: {
    scopeType: string;
    userId: string;
    groupId: string;
  };
}

export interface IApplyPlanTableReport extends ITableReport {
  statusDisplay: string;
  status: ApplyOptionPlanStatus;
  lastRequestStatusStr: string;
  lastRequestStatus: ApplyOptionsLastRequestStatus;
}

export enum ApplyOptionsLastRequestStatus {
  Success = 1,
  Fail,
  Pending,
  ReadyToSend,
}

export enum ApplyOptionPlanStatus {
  Active = 1,
  Inactive,
}
